import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=82c81b4e&scoped=true"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"
import style0 from "./payment.vue?vue&type=style&index=0&id=82c81b4e&prod&scoped=true&lang=css"
import style1 from "./payment.vue?vue&type=style&index=1&id=82c81b4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c81b4e",
  null
  
)

export default component.exports